<template>
  <v-select
    :value="value"
    :items="items"
    :label="label"
    :append-outer-icon="value ? 'mdi-close' : null"
    return-object
    hide-details
    :menu-props="{ 'min-width': '250px' }"
    @click:append-outer="emit('input', null)"
    @input="updateValue"
  >
    <template #item="{item}">
      <p class="w-100 my-auto">
        {{ item.text }}
      </p>
      <div class="text-right">
        <v-icon
          small
          :color="item.color"
        >
          mdi-circle
        </v-icon>
      </div>
    </template>
    <template
      v-if="value"
      #append
    >
      <v-icon
        small
        class="mt-1"
        :color="value.color"
      >
        mdi-circle
      </v-icon>
    </template>
  </v-select>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { TranslateResult } from 'vue-i18n';

const props = defineProps({
  value: { type: Object as PropType<any | null>, required: true },
  label: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  items: { type: Object as PropType<Array<any>>, required: true },
});

const emit = defineEmits(['input']);

const updateValue = (s: Object) => {
  emit('input', s);
};

</script>
